/**
 * When a scroll block is active the body is pulled up by the height of the scroll position.
 * The value is stored in a CSS variable.
 */
export function getBodyOffsetTop() {
    const bodyOffsetTop = parseInt(document.body.style.top, 10);
    if (Number.isNaN(bodyOffsetTop)) {
        return 0;
    }
    return bodyOffsetTop;
}
export function getTooltipPosition(trigger) {
    const x = 0;
    const y = window.scrollY - getBodyOffsetTop();
    const { top, left } = trigger.getBoundingClientRect();
    return {
        x: x + left,
        y: y + top,
    };
}
